import React, { useEffect, useMemo, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { Button } from "../../../../../../stories/Button/Button";
import Total from "../../../../../../images/dashboard/Total Count.svg";
import Working from "../../../../../../images/dashboard/Working.svg";
import NotWorking from "../../../../../../images/dashboard/Not Working.svg";
import Input from "../../../../../../stories/Input/Input";
import AssetStatusSelect from "../../../../../../customComponents/AssetStatusSelect";
import { FilterBarProps } from "../../../maps/ticketdetails/TicketsRaisedList";
import {
  DEFAULT_TIME,
  EMPTY_STRING,
  emptyFunc
} from "../../../../../../utils/constants";
import useLabels from "../../../../../../customHooks/useLabels";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import SubsidiarySelect from "../../../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../../../customComponents/SiteSelect";
import JunctionsAutocomplete from "../../../../../../customComponents/JunctionsAutocomplete";
import {
  FlexForColumns,
  HEADER_TEXT_ALIGN,
  SLNO_TEXT_ALIGN,
  TABLE_ROW_HEIGHT
} from "../../../../../../styles/Variables";
import { AtsStckItemDetailsEdges } from "../../../masters/items/queries/types";
import { StockEntryTable } from "../../../purchase/stockentry/Add/Add";

import {
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel
} from "@mui/x-data-grid-pro";
import { ColumnVisibilityFor } from "../../../../../../utils/Enum.Datagrid";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import EyeWhite from "../../../../../../images/EyeWhite.svg";
import { CustomDrawer } from "../../../../../../styles/CustomDrawerStyles";
import ViewAssetDetails from "../../../maps/ticketing/raisedtickets/ViewAssetDetails";
import { toStandardDate } from "../../../../../../utils/UtilFunctions";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const ItemDetails = ({ setModalFlag }: Props) => {
  const [viewAssetDetails, setViewAssetDetails] = useState(false);
  const { company_id, sub_id, siteID, junctionID } = useUrlParams();
  const CardsData = [
    {
      image: `${Total}`,
      label: "Total",
      total: 0
    },
    {
      image: `${Working}`,
      label: "Working",
      total: 0
    },
    {
      image: `${NotWorking}`,
      label: "Tickets Raised",
      total: 0
    }
  ];

  const [filterFormData, setFilterFormData] = useState<FilterBarProps>({
    asset: 0,
    assetStatus: "",
    priority: "",
    searchData: "",
    ticketReason: "",
    ticketStatus: "",
    date: "",
    subsidiary: 0,
    endDate: "",
    fromDate: ""
  });

  const {
    itemLabel,
    subsidiaryLabel,
    subsidiarySiteLabel,
    junctionLabel,
    companyLabel
  } = useLabels();
  const [items, setItems] = useState<AtsStckItemDetailsEdges[]>([]);

  const columns: GridColDef[] = [
    {
      headerName: "Sl",
      field: StockEntryTable.SL_No,
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      hideable: false,
      flex: FlexForColumns.SLNO,
      cellClassName: "number-cell"
    },
    ...(items && items.length && items[0].node.item.trackSerial
      ? [
          {
            headerName: "Serial No.",
            field: StockEntryTable.Serial_No,
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell"
          }
        ]
      : []),

    {
      headerName: `${companyLabel}`,
      field: `${companyLabel}`,
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      hideable: false,
      flex: FlexForColumns.NAME,
      cellClassName: "number-cell"
    },
    {
      headerName: `${subsidiaryLabel}`,
      field: subsidiaryLabel,
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      hideable: false,
      flex: FlexForColumns.NAME,
      cellClassName: "number-cell"
    },
    {
      headerName: `${subsidiarySiteLabel}`,
      field: subsidiarySiteLabel,
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      hideable: false,
      flex: FlexForColumns.NAME,
      cellClassName: "number-cell"
    },
    {
      headerName: `Maintained By`,
      field: "maintainedBy",
      headerAlign: HEADER_TEXT_ALIGN,
      align: SLNO_TEXT_ALIGN,
      hideable: false,
      flex: FlexForColumns.NAME,
      cellClassName: "number-cell"
    },
    ...(items && items.length && items[0].node.item.trackAmc
      ? [
          {
            headerName: "AMC Start Date",
            field: StockEntryTable.AMC_Start_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell"
          },
          {
            headerName: "AMC End Date",
            field: StockEntryTable.AMC_End_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell"
          }
        ]
      : []),

    ...(items && items.length && items[0].node.item.trackBrand
      ? [
          {
            headerName: "Brand",
            field: StockEntryTable.Brand,
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell"
          }
        ]
      : []),
    ...(items && items.length && items[0].node.item.trackModel
      ? [
          {
            headerName: "Model",
            field: StockEntryTable.Model,
            headerAlign: HEADER_TEXT_ALIGN,
            align: SLNO_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell"
          }
        ]
      : []),
    ...(items && items.length && items[0].node.item.trackBatch
      ? [
          {
            headerName: "Batch.",
            field: StockEntryTable.Batch,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION
          }
        ]
      : []),
    ...(items && items.length && items[0].node.item.trackExpiry
      ? [
          {
            headerName: "Expiry",
            field: StockEntryTable.Expiry,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell"
          }
        ]
      : []),
    ...(items && items.length && items[0].node.item.trackWarranty
      ? [
          {
            headerName: "Warranty Start Date",
            field: StockEntryTable.Warranty_Start_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell"
          },

          {
            headerName: "Warranty End Date",
            field: StockEntryTable.Warranty_End_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell"
          }
        ]
      : []),
    ...(items && items.length && items[0].node.item.trackMaintenance
      ? [
          {
            headerName: "Maintained By",
            field: StockEntryTable.Maintained_By,
            headerAlign: HEADER_TEXT_ALIGN,
            flex: FlexForColumns.DESCRIPTION
          }
        ]
      : []),

    ...(items && items.length && items[0].node.item.trackGeoLocation
      ? [
          {
            headerName: "Geo Location",
            field: StockEntryTable.Geo_Location,
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.DESCRIPTION
          }
        ]
      : []),

    ...(items && items.length && items[0].node.item.trackInsurance
      ? [
          {
            headerName: "Insurance Start Date.",
            field: StockEntryTable.INC_Start_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell"
          },
          {
            headerName: "Insurance End Date.",
            field: StockEntryTable.INC_end_Date,
            headerAlign: HEADER_TEXT_ALIGN,
            hideable: false,
            flex: FlexForColumns.DESCRIPTION,
            cellClassName: "number-cell"
          }
        ]
      : []),

    {
      headerName: "Stock Location",
      field: StockEntryTable.Stock_Location,
      headerAlign: HEADER_TEXT_ALIGN,
      hideable: false,
      flex: FlexForColumns.DESCRIPTION
    },
    {
      headerName: "Actions",
      field: "action",
      headerAlign: HEADER_TEXT_ALIGN,
      hideable: false,
      flex: FlexForColumns.DESCRIPTION,
      renderCell: (params) => {
        return (
          <>
            <button
              className="maps-comp-details__view"
              onClick={() => setViewAssetDetails(!viewAssetDetails)}
            >
              View Details
              <img src={EyeWhite} alt="" />
            </button>
          </>
        );
      }
    }
  ];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    React.useState<GridColumnVisibilityModel>({
      id: true,
      serial_no: true,
      companyLabel: false,
      subsidiaryLabel: false,
      subsidiarySiteLabel: false,
      junctionLabel: true,
      amc_start_date: true,
      amc_end_date: false,
      batch: false,
      expiry: false,
      brand: true,
      model: true,
      warranty_start_date: false,
      warranty_end_date: false,
      geo_location: false,
      inc_start_date: false,
      inc_end_date: false,
      stock_location: false,
      poleNum: true,
      maintainedBy: false
    });

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.REPORTS_ASSET_DETAILS
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.REPORTS_ASSET_DETAILS,
      JSON.stringify(newModel)
    );
  };
  const rows: GridValidRowModel[] = useMemo(() => {
    return items.map(({ node: data }, index) => {
      return {
        id: index + 1,
        serial_no: data.prodSerialNo,
        batch: data.prodBatchNo,
        expiry:
          toStandardDate(data.prodExpiryDate) === toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodExpiryDate),
        brand: data.prodBrand,
        model: data.prodModel,
        warranty_start_date:
          toStandardDate(data.prodWarrantyStartDate) ===
          toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodWarrantyStartDate),
        warranty_end_date:
          toStandardDate(data.prodWarrantyEndDate) ===
          toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodWarrantyEndDate),
        amc_start_date:
          toStandardDate(data.prodAmcStDate) === toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodAmcStDate),

        amc_end_date:
          toStandardDate(data.prodAmcEndDate) === toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodAmcEndDate),

        geo_location: "",
        inc_start_date:
          toStandardDate(data.prodInsuranceStDate) ===
          toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodInsuranceStDate),

        inc_end_date:
          toStandardDate(data.prodInsuranceEndDate) ===
          toStandardDate(DEFAULT_TIME)
            ? "-"
            : toStandardDate(data.prodInsuranceEndDate),

        stock_location: "",
        [`${companyLabel}`]: data.currentCompany.name,
        [`${subsidiaryLabel}`]: data.currentSubsidiary.name,
        [`${subsidiarySiteLabel}`]: data.currentSite.name,
        [`${junctionLabel}`]: data.currentJunction.name,
        poleNum: data.poleNum,
        maintainedBy: data.vendorDetails.desc,
      };
    });
  }, [items]);
  // const rows: GridValidRowModel[] = [
  //   {
  //     id:1,
  //   }
  // ];
  return (
    <div className="asset-sum-items">
      <div className="asset-sum-items__title">
        <Title>Item Name (Item Code)</Title>
        <img src={Close} alt="" onClick={() => setModalFlag(false)} />
      </div>
      <div className="asset-sum-items__b">
        <b>Zone </b>
      </div>
      <div className="asset-sum-items__cards">
        {CardsData.map((res) => {
          return (
            <div className="asset-sum-items__card">
              <div className="asset-sum-items__card--flex">
                <img src={res.image} alt="" />
                <span>{res.label}</span>
              </div>
              <b>{res.total}</b>
            </div>
          );
        })}
      </div>
      <div className="asset-sum-items__filters row g-0">
        <div className="col-2">
          <Input id="data_search" placeholder="Search..." />
        </div>
        {!sub_id ? (
          <div className="col-2">
            <SubsidiarySelect
              onChange={(newValue) => {
                // if (newValue) {
                //   dispatch({
                //     type: payloadTypes.SET_SUB_ID,
                //     payload: {
                //       subsidiaryId: newValue.node.id,
                //     },
                //   });
                // } else {
                //   dispatch({
                //     type: payloadTypes.SET_SUB_ID,
                //     payload: {
                //       subsidiaryId: 0,
                //     },
                //   });
                //   dispatch({
                //     type: payloadTypes.SET_SUB_SITE_ID,
                //     payload: {
                //       subSiteId: 0,
                //     },
                //   });
                //   dispatch({
                //     type: payloadTypes.SET_JUNCTION_ID,
                //     payload: {
                //       junctionID: 0,
                //     },
                //   });
                // }
              }}
              label={subsidiaryLabel}
              companyID={company_id ? company_id : 0}
              onKeyDown={emptyFunc}
              value={0}
            />
          </div>
        ) : null}
        {!siteID ? (
          <div className="col-2">
            <SiteSelect
              onChange={(newValue) => {
                // if (newValue) {
                //   dispatch({
                //     type: payloadTypes.SET_SUB_SITE_ID,
                //     payload: {
                //       subSiteId: newValue.value,
                //     },
                //   });
                // } else {
                //   dispatch({
                //     type: payloadTypes.SET_SUB_SITE_ID,
                //     payload: {
                //       subSiteId: 0,
                //     },
                //   });
                //   dispatch({
                //     type: payloadTypes.SET_JUNCTION_ID,
                //     payload: {
                //       junctionID: 0,
                //     },
                //   });
                // }
              }}
              companyId={company_id ? company_id : 0}
              subsidiaryId={sub_id ? sub_id : 0}
              onKeyDown={emptyFunc}
              value={0}
              label={subsidiarySiteLabel}
            />
          </div>
        ) : null}
        <div className="col-2">
          <JunctionsAutocomplete
            onChange={(newValue) => {
              // if (newValue) {
              //   dispatch({
              //     type: mapsPayloadType.JUNCTION,
              //     payload: {
              //       junction: newValue,
              //     },
              //   });
              // } else {
              //   dispatch({
              //     type: mapsPayloadType.JUNCTION,
              //     payload: {
              //       junction: null,
              //     },
              //   });
              // }
            }}
            label={junctionLabel}
            companyID={company_id ? company_id : 0}
            subsidiaryID={sub_id ? sub_id : 0}
            siteID={siteID ? siteID : 0}
            onKeyDown={emptyFunc}
            value={junctionID ? junctionID : 0}
          />
        </div>
        <div className="col"></div>
        <div className="col-2">
          <AssetStatusSelect
            onChange={(newValue) => {
              if (newValue) {
                setFilterFormData({
                  ...filterFormData,
                  assetStatus: newValue
                });
              } else {
                setFilterFormData({
                  ...filterFormData,
                  assetStatus: EMPTY_STRING
                });
              }
            }}
            value={filterFormData.assetStatus}
            label={`${itemLabel} Status`}
          />
        </div>
      </div>
      <div className="asset-sum-items__table">
        <StyledDatagrid
          columns={columns}
          rows={rows}
          rowHeight={TABLE_ROW_HEIGHT}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={handleColumnVisibilityChange}
          initialState={{
            columns: {
              columnVisibilityModel: columnVisibilityModel
            }
          }}
          disableRowSelectionOnClick
          hideFooter
          // onRowsScrollEnd={() => {
          //   if (data) {
          //     handleScroll();
          //   }
          // }}
        />
      </div>
      <Button mode="export" />
      {/* <Button mode="pdf">Download</Button>*/}
      <Button mode="cancel" onClick={() => setModalFlag(false)} />
      <CustomDrawer
        anchor="right"
        open={viewAssetDetails}
        onClose={() => setViewAssetDetails(!viewAssetDetails)}
      >
        <ViewAssetDetails setModalFlag={setViewAssetDetails} itemId={0} />
      </CustomDrawer>
    </div>
  );
};

export default ItemDetails;